import React, { useCallback, useEffect, useState } from "react";

import en from "./locales/en";
import zh_CN from "./locales/zh-cn";
import { useLocale } from "../../utils/i18n";
import { FaqItem } from "../../assets/faqs";
import { FormattedMessage } from "react-intl";
import CardLayout from "../../layouts/CardLayout";
import Faq from "../../components/Faq";
import { BackTop } from "antd";
import TrackView from "../../components/Onetrack/TrackView";
import { request, requestUrl } from "../../utils/request";
import { get } from "lodash";

const locales: Record<string, FaqItem[]> = {
  "zh-cn": zh_CN,
  en,
};

interface ITEM {
  key: string;
  id: string;
  title: string;
  content: string;
}

const Service: React.FC = () => {
  const [locale] = useLocale();
  const [dataAll, setDataAll] = useState([]);

  const contentHandle = useCallback(
    (content: { id: string }) => {
      const hotline = get(content, "hotline", "");
      const email = get(content, "email", "");
      const OnlineService = get(content, "OnlineService", "");
      const ServiceHour_cn = get(content, "ServiceHour_cn", "");
      const ServiceHour_en = get(content, "ServiceHour_en", "");
      const ID = get(content, "ID", "");

      return (
        (locale === "zh-cn" &&
          (
            `在此国家/地区的客户服务团队提供如下联系方式：` +
            (ID === "CN" && `\n- **客服官网**：https://www.mi.com/service`) +
            (hotline && `\n- **客服热线**：${hotline}`) +
            (email && `\n- **电子邮件**：${email}`) +
            (OnlineService &&
              `\n- **在线客服**：[点击进入](${OnlineService})`) +
            (ServiceHour_cn && `\n\n服务时间: ${ServiceHour_cn}`)
          )
            .split(/null|false/)
            .join("")) ||
        (
          `The customer service team in this country / region provides the following contact methods:` +
          (ID === "CN" && `\n- **Websites**: https://www.mi.com/service`) +
          (hotline && `\n- **Hotline**: ${hotline}`) +
          (email && `\n- **Email**: ${email}`) +
          (OnlineService &&
            `\n- **Online Bot and Chat**: [Click Here](${OnlineService})`) +
          (ServiceHour_en && `\n\nService Hour: ${ServiceHour_en}`)
        )
          .split(/null|false/)
          .join("")
      );
    },
    [locale]
  );

  const requestData = useCallback(() => {
    request(requestUrl, {
      method: "get",
      headers: { "Cache-Control": "no-cache" },
    }).then((res) => {
      res.map((item: ITEM) => {
        return Object.assign(item, {
          key: get(item, "ID"),
          id: get(item, "ID"),
          title:
            (locale === "zh-cn" && get(item, "title_cn")) ||
            get(item, "title_en"),
          content: contentHandle(item),
        });
      });
      setDataAll(res);
    });
  }, [locale, contentHandle]);

  useEffect(() => {
    requestData();
  }, [requestData]);

  const dataSource = dataAll || locales[locale];

  return (
    <TrackView tip="71.3.0.1.2157">
      <CardLayout title={<FormattedMessage id="Service" />}>
        <Faq dataSource={dataSource} anchor />
        <BackTop visibilityHeight={200} />
      </CardLayout>
    </TrackView>
  );
};

export default Service;
